// React
import React from "react";
// Material
import { Divider } from "@material-ui/core";
// Components
import { ElementsCustom } from "@components/Elements";

const Dialog360FormFields = ({ t, dialog360, updateElement }) => (
  <>
    {/* PHONE */}
    <ElementsCustom
      t={t}
      type={"dialog360"}
      input_type={"input"}
      element_type={"phone"}
      element={dialog360.info.phone}
      updateElement={updateElement}
    />
    <Divider />
    {/* APP ID */}
    <ElementsCustom
      t={t}
      type={"dialog360"}
      input_type={"input"}
      element_type={"app_id"}
      element={dialog360.info.app_id}
      updateElement={updateElement}
    />
    <Divider />
    {/* META TOKEN */}
    <ElementsCustom
      t={t}
      type={"dialog360"}
      input_type={"input"}
      element_type={"meta_token"}
      element={dialog360.info.meta_token}
      updateElement={updateElement}
    />
  </>
);

export default Dialog360FormFields;
